module.exports = __webpack_public_path__ + "static/media/car13.37a14cf1.png";